import VerifyOtp from "./verify-otp";

export default VerifyOtp;
